<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
                <slot name="buttons"></slot>
            </div>
            <div class="align-self-end">
                <input-debounced
                    v-model="search"
                    :clearable="true"
                    :autofocus="true"
                    placeholder="Search"
                    class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
            :base-url="urlWithFilters"
            ref="baseTable"
            @load-success="onLoadSuccess"
            @refresh="onRefresh"
            :current-page="currentPage"
            v-loading="isRefreshing"
            element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                    :data="items"
                    stripe
                    class="w-100"
                >
                    <el-table-column
                        prop="model.id"
                        label="Id"
                        min-width="80"
                    ></el-table-column>
                    <el-table-column
                        prop="model.contact.full_name"
                        label="Contact"
                        min-width="150"
                    ></el-table-column>
                    <el-table-column
                        prop="model.contact.filemaker_id"
                        label="Filemaker"
                        min-width="80"
                    ></el-table-column>
                    <el-table-column
                        prop="model.contact.safe_phone_number"
                        label="Contact phone"
                        min-width="140"
                        v-slot="{row}"
                    >
                        <contact-phone-number-column :row="row"></contact-phone-number-column>
                    </el-table-column>
                    <el-table-column
                        prop="model.outgoing_number.presentation"
                        label="Outgoing number"
                        min-width="250"
                    ></el-table-column>
                    <el-table-column
                        label="Actions"
                        v-slot="{row}"
                    >
                        <actions-column :row="row" @delete="onDelete" @export="onExport"></actions-column>
                    </el-table-column>
                </el-table>
            </template>
        </base-table>
        <el-pagination
            layout="prev, pager, next"
            :total="total"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            class="text-right"
        ></el-pagination>
    </div>
</template>

<script>
  import TableWithPagination from '../table-with-pagination';
  import ActionsColumn from './actions-column';
  import {addQueryParams} from '../../libs/url';
  import ContactPhoneNumberColumn from './contact-phone-number-column';

  export default {
    extends: TableWithPagination,

    components: {
      ActionsColumn,
      ContactPhoneNumberColumn,
    },

    data() {
      return {
        search: null,
        filters: {},
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },
    },

    watch: {
      search: function (value) {
        this.filters = value
          ? _.assign({}, this.filters, {search: value})
          : this.filters = _.omit(this.filters, ['search']);
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.baseTable.refresh();
      },

      /**
       * @param {string} url
       */
      onDelete({url}) {
        axios.post(url, {_method: 'DELETE'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          });
      },

      /**
       * @param {string} url
       * @event show-export-conversion-dialog
       */
      onExport({url}) {
        eventBus.$emit('show-export-conversion-dialog', url);
      },
    }
  }
</script>
